const productsData = [
  {
    id: 'rotativa',
    title: 'Rotativa TNO Network (micros)',
    product: 'Plan Rotativa 24/7',
    investment: '$120 / mes',
    impacts: [
      '12 impactos diarios (360 al mes): micros de 30–45 segundos en la señal 24/7.',
      'Mismo producto rotativo: piezas semanales (1–3 min) sobre bienestar familiar con identidad Papaupa.',
      'Presencia constante en audio y video; recordación del eslogan «Un pedacito de cielo» en toda la programación.',
    ],
  },
  {
    id: 'menciones',
    title: 'Menciones en Programas',
    product: 'Endoso en antena (3 shows)',
    investment: '$100 / mes',
    impacts: [
      'Mención de agradecimiento y endoso directo de los conductores.',
      'Punto de Fe, Somos Padres y 2do Escalón: narrativa alineada a fe, crianza y crecimiento.',
      'La marca como parte de la conversación, no como cuña aislada.',
    ],
  },
  {
    id: 'inserts',
    title: 'Inserts y Banners',
    product: 'Presencia visual en pantalla y web',
    investment: '$40 / mes',
    impacts: [
      'Inserts visuales (logos y claquetas) durante los tres programas.',
      'Banners horizontales fijos en el portal web de TNO Network.',
      'Cintillo animado en consejos familiares: «Este pedacito de cielo es traído a ti por Papaupa».',
    ],
  },
  {
    id: 'redes',
    title: 'Estrategia en Redes',
    product: 'Derivados y comunidad TNO',
    investment: '$40 / mes',
    impacts: [
      'Logo de Papaupa en Reels y Shorts derivados de los programas.',
      'Menciones en historias de las redes oficiales de TNO Network.',
      'Contenido compartible que refuerza la identidad visual de la marca.',
    ],
  },
];

export default productsData;
